<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

    <transition name="fade">
      <div class="tabNav" v-show="isshowTab">
        <van-tabs
          v-model="activeTab"
          background="rgba(0, 0, 0, 0.5)"
          color="#1989fa"
          title-inactive-color="#fff"
          title-active-color="#fff"
          @click="changTabs"
        >
          <van-tab title="区域沙盘"></van-tab>
          <van-tab title="项目沙盘"></van-tab>
        </van-tabs>
      </div>
    </transition>

    <transition name="fade">
      <div class="houseTabNav" v-show="isshowHouseTab">
        <van-tabs
          v-model="activeHouseTab"
          background="rgba(0, 0, 0, 0.5)"
          color="#1989fa"
          title-inactive-color="#fff"
          title-active-color="#fff"
          @click="changHouseTabs"
        >
          <van-tab title="户型一"></van-tab>
          <van-tab title="户型二"></van-tab>
        </van-tabs>
      </div>
    </transition>

    <div class="footerNav">
      <van-tabbar v-model="active" :fixed="false" @change="changeTabbar" :border="false">
        <van-tabbar-item @click="switchPanorama">
          <img slot="icon" src="./assets/img/icon1.png">
          全景鸟瞰
        </van-tabbar-item>
        <van-tabbar-item @click="switchHouse">
          <img slot="icon" src="./assets/img/icon2.png">
          户型鉴赏
        </van-tabbar-item>
        <van-tabbar-item>
          <img slot="icon" src="./assets/img/icon3.png">
          区位优势
        </van-tabbar-item>
        <van-tabbar-item @click="switchMore">
          <img slot="icon" src="./assets/img/icon5.png">
          更多
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <van-popup v-model="showMore">
      <img src="./assets/img/introduce.jpg" alt="">
    </van-popup>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, Tab, Tabs, Popup } from "vant";
export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      activeHouseTab: 0,
      isshowTab: false,
      isshowHouseTab: false,
      showMore: false
    };
  },
  // mounted() {
  //   console.log(this.$route.path);
  //   if (this.$route.path === "/" || this.$route.path === "/area") {
  //     this.isshowTab = true;
  //     this.isshowHouseTab = false;
  //     this.activeTab = 0;
  //     this.active = 0;
  //   } else if (this.$route.path === "/project") {
  //     this.isshowTab = true;
  //     this.isshowHouseTab = false;
  //     this.activeTab = 1;
  //     this.active = 0;
  //   } else if (this.$route.path === "/location") {
  //     this.isshowTab = false;
  //     this.isshowHouseTab = false;
  //     this.active = 2;
  //   } else if (this.$route.path === "/houseOne") {
  //     this.isshowTab = false;
  //     this.isshowHouseTab = true;
  //     this.activeHouseTab = 0;
  //     this.active = 1;
  //   } else if (this.$route.path === "/houseTwo") {
  //     this.isshowTab = false;
  //     this.isshowHouseTab = true;
  //     this.activeHouseTab = 1;
  //     this.active = 1;
  //   } else {
  //     this.isshowTab = false;
  //     this.isshowHouseTab = false;
  //     this.active = 3;
  //   }
  // },

  computed:{
    routerUrl: function () {
      return this.$route.path
    }
  },

  watch: {
    routerUrl: function(val) {
      console.log(val);
      if(val==='/arer') {
        this.active = 0;
        this.isshowTab = true;
        this.activeTab = 0;
      } else if(val==='/project') {
        this.active = 0;
        this.isshowTab = true;
        this.activeTab = 1;
      } else if (val==='/houseOne' || val==='/houseTwo' ) {
        this.active = 1;
        this.isshowHouseTab = true;
        this.activeHouseTab = 0;
      } else if (val==='/europeOne' || val==='/europeTwo' || val==="/europeThree") {
        this.active = 1;
        this.isshowHouseTab = true;
        this.activeHouseTab = 1;
      } else if (val==='/location') {
        this.active = 2;
      } 
    }
  },

  methods: {
    changeTabbar(active) {
      if (active === 0) {
        this.isshowHouseTab = false;
      } else if (active === 2) {
        this.isshowTab = false;
        this.isshowHouseTab = false;
        this.$router.push({ path: "/location" });
      } else if (active === 1) {
        this.isshowTab = false;
      } else if (active === 3) {
        this.isshowTab = false;
        this.isshowHouseTab = false;
      }
    },
    switchPanorama() {
      this.isshowTab = !this.isshowTab;
    },
    switchHouse() {
      this.isshowHouseTab = !this.isshowHouseTab
    },
    switchMore() {
      this.showMore = !this.showMore;
    },
    changTabs(index) {
      if (index === 0) {
        this.$router.push({ path: "/area" });
      } else {
        this.$router.push({ path: "/project" });
      }
    },
    changHouseTabs(index) {
      if (index === 0) {
        this.$router.push({ path: "/houseOne" });
      } else {
        this.$router.push({ path: "/europeOne" });
      }
    }
  }
};
</script>

<style lang="less">
@import url("//at.alicdn.com/t/font_740556_ghtyuz0vf3i.css");

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  position: relative;
  height: 100%;
  overflow: hidden;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  .tabNav {
    width: 42%;
    position: absolute;
    left: 10px;
    bottom: 60px;
    z-index: 999;
    .van-tabs__wrap {
      border-radius: 5px;
    }
    /deep/.van-tabs__wrap {
      height: 38px;
    }
    /deep/.van-tab {
      line-height: 38px;
    }
  }

  .houseTabNav {
    width: 42%;
    position: absolute;
    left: 70px;
    bottom: 60px;
    z-index: 999;
    .van-tabs__wrap {
      border-radius: 5px;
    }
    /deep/.van-tabs__wrap {
      height: 38px;
    }
    /deep/.van-tab {
      line-height: 38px;
    }
  }

  .footerNav {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    // height: 130/30rem;
    // max-height: 100px;
    // background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    .van-tabbar {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  .van-popup {
    width: 100%;
    text-align: center;
    img{
      width: 80%;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.7s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
